// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type NoteFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from note-filled.svg
 */
export default function NoteFilledIcon(props: NoteFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="NoteFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M15.995 1.85A2 2 0 0 0 14 0H2l-.15.005A2 2 0 0 0 0 2v12l.005.15A2 2 0 0 0 2 16h3a1 1 0 0 0 1-1V9a1 1 0 0 1 1-1h8a1 1 0 0 0 1-1V2zM16 9.25a.25.25 0 0 0-.25-.25H8a1 1 0 0 0-1 1v5.75c0 .138.112.25.25.25z"
        />
      </g>
    </svg>
  );
}
